module.exports = __webpack_public_path__ + "img/google-play.97d11556.png";